import CustomCoordendasForm from "@/erp/venta-corporativa/preventa_corporativo/shared/form_coordenadas/CustomCoordendasForm";
import { gridSizeMdLg6, handleErrorForm, ROUTER_PATHS } from "@/shared";
import { getAllRadius, getIpv4Groups } from "@/shared/actions/erp";
import { useFetchPostBras, useFetchPutBras } from "@/shared/actions/erp/configuracion-red/bras.actions";
import { CustomDynamicSearch, CustomTextField, SingleTableBoxScene, SwitchComponenteForm, TabTextLabel } from "@/shared/components/ui";
import { Ipv4Group, Radius } from "@/shared/interfaces";
import { IBras, IBrasForm } from "@/shared/interfaces/erp/configuracion-red/bras/bras.interface";
import { newBrasSchema } from "@/shared/utils/validation-schemas/erp/configuracion-red/bras.schema";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

interface SaveBrasProps {
  title: string
  dataBras?: IBras | null
}
export default function SaveBras({
  title,
  dataBras
}: SaveBrasProps) {

  const navigate = useNavigate();

  ///* form
  const form = useForm<IBrasForm>({
    resolver: yupResolver(newBrasSchema),
    defaultValues: {
      coordenadas: dataBras?.coordenadas ?? '0,0',
      grupo_ipv4: dataBras?.grupo_ipv4 ?? '',
      estado: true
    }
  });

  const {
    reset,
    control,
    formState: { errors },
    handleSubmit
  } = form;


  ///* react query

  const {
    mutateAsync: mutateAsyncPostBras
  } = useFetchPostBras({
    navigate,
    returnUrl: `${ROUTER_PATHS.configuracionRED.brasNav}`
  })

  const {
    mutateAsync: mutateAsyncPutBras
  } = useFetchPutBras({
    navigate,
    returnUrl: `${ROUTER_PATHS.configuracionRED.brasNav}`
  })

  // const {
  //   data: allRadius,
  //   isLoading: isLoadingRadius,
  //   isRefetching: isRefetchingRadius,
  // } = useFetchRadius({
  //   enabled: true,
  //   params: {
  //     page_size: 1000,
  //   },
  // })


  useEffect(() => {

    if (!dataBras) return;

    reset(dataBras)

    return () => {

    }

  }, [dataBras])

  ///* handle

  const onSubmit = async (form: IBrasForm) => {

    ///* editar bras
    if (dataBras) {
      mutateAsyncPutBras({
        id: dataBras.id_bras,
        data: form
      })
      return;
    }

    ///* crear bras
    await mutateAsyncPostBras({
      data: form
    })
  }

  return (
    <>
      <SingleTableBoxScene
        title={title}

        ///* regresar
        enableBackBtn={true}
        backPageUrl={ROUTER_PATHS.configuracionRED.brasNav}

        ///* guardar
        enableCreateOrEditBtn={true}
        fnCreateOrEdit={handleSubmit((form) => {
          onSubmit(form)
        }, (error) => {
          handleErrorForm(error)
        })}
      >
        <Grid container spacing={3}>
          <CustomTextField
            disabled
            control={control}
            type="none"
            name="numero_referencia"
            defaultValue={form.getValues().numero_referencia}
            size={gridSizeMdLg6}
            label={'Número referencia'}
            error={errors.numero_referencia}
            helperText={errors.numero_referencia?.message}
            required={false}
          />

          <SwitchComponenteForm
            label={form.watch()?.estado ? 'Activo' : 'Inactivo'}
            size={gridSizeMdLg6}
            control={form.control}
            defaultValue={!!form.getValues()?.estado}
            name="estado"
          />
          <CustomTextField
            disabled={false}
            control={control}
            name="nombre"
            defaultValue={form.getValues().nombre}
            size={gridSizeMdLg6}
            label={'Nombre'}
            error={errors.nombre}
            helperText={errors.nombre?.message}
          />

          <CustomTextField
            disabled={false}
            control={control}
            name="modelo"
            defaultValue={form.getValues().modelo}
            size={gridSizeMdLg6}
            label={'Modelo/Número'}
            error={errors.modelo}
            helperText={errors.modelo?.message}
            required={false}
          />

          <CustomTextField
            disabled={false}
            control={control}
            name="hostname"
            defaultValue={form.getValues().hostname}
            size={gridSizeMdLg6}
            label={'Hostname'}
            error={errors.hostname}
            helperText={errors.hostname?.message}
          />

          <CustomTextField
            disabled={false}
            control={control}
            name="password"
            defaultValue={form.getValues().password}
            size={gridSizeMdLg6}
            label={'Password'}
            error={errors.password}
            helperText={errors.password?.message}
          />
          {/* <CustomAutocomplete<Radius>
            label="Radius"
            name="radius"
            //// options
            options={allRadius?.data?.data || []}
            // label & id as fk
            valueKey="nombre"
            actualValueKey="codigo"
            defaultValue={form.getValues().radius || ''}
            isLoadingData={isLoadingRadius || isRefetchingRadius}
            //// validation
            control={form.control}
            error={errors.radius}
            helperText={errors.radius?.message}
            required={false}
            size={gridSizeMdLg6}
          /> */}
          <CustomDynamicSearch<Ipv4Group>
            label="Grupo IPV4"
            name='grupo_ipv4'
            valueKey={"nombre"}
            actualValueKey={"codigo"}
            defaultValue={dataBras?.grupo_ipv4 || form.getValues()?.grupo_ipv4 || ""}
            functionToGetData={getIpv4Groups}
            paramsToGetData={{
              es_bras:true
            }}
            error={errors.grupo_ipv4}
            control={form.control}
            helperText={errors.grupo_ipv4?.message}
            size={gridSizeMdLg6}
            // disabled={!!!form.getValues()?.es_bras}
          />
          <CustomDynamicSearch<Radius>
            size={gridSizeMdLg6}
            label={'Radius'}
            name="radius"
            valueKey="nombre"
            actualValueKey="codigo"
            functionToGetData={getAllRadius}
            defaultValue={ dataBras?.radius || form.getValues()?.radius || ""}
            control={form.control}
            error={form.formState.errors.radius}
            helperText={form.formState.errors.radius?.message}
          />

          {/* <CustomTextField
            disabled
            control={control}
            label={'Radius (No agregada por parte del back)'}
            name="radius"
            defaultValue={form.getValues().radius}
            size={gridSizeMdLg6}
            error={errors.radius}
            helperText={errors.radius?.message}
          /> */}

          <TabTextLabel text="Ubicación" mt={5}/>

          <CustomTextField
            disabled={false}
            control={control}
            name="direccion"
            defaultValue={form.getValues().direccion}
            size={gridSizeMdLg6}
            label={'Dirección'}
            error={errors.direccion}
            helperText={errors.direccion?.message}
          />


          <CustomCoordendasForm
            form={form}
            label="Coordendas"
            name="coordenadas"
            defaultValue={form.watch().coordenadas}
            key={'key_bras_coordenadas'}
            size={gridSizeMdLg6}
            onlyValueLocation={true}
            enableLocationOnChange={false}
          />




        </Grid>

      </SingleTableBoxScene>
    </>
  )

}